import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CREATE_SERVICE,
  REMOVE_SERVICE,
  REMOVE_SERVICE_TASK,
  REMOVE_SERVICE_TASK_ASSIGNMENT,
  UPDATE_SERVICE,
} from '../graphql/mutation/services.mutation';
import { GET_SERVICE_BY_ID, GET_SERVICE_DROPDOWN, GET_SERVICES } from '../graphql/queries/services.query';

@Injectable({
  providedIn: 'root',
})
export class ServiceManagementService {
  constructor(private apollo: Apollo) {}

  fetchServiceById(id: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_SERVICE_BY_ID,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.service || []));
      
  }
  fetchServices(search: string = ''): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_SERVICES,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.services || []));
      
  }
  serviceDropdown(search: string = ''): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_SERVICE_DROPDOWN,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.serviceDropDown || []));
      
  }

  createService(createServiceInput: any, serviceTasks: any): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: CREATE_SERVICE,
      variables: {
        createServiceInput,
        serviceTasks
      },
    });
  }

  updateService(id:any, updateServiceInput: any, serviceTasks: any): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: UPDATE_SERVICE,
      variables: {
        id,
        updateServiceInput,
        serviceTasks
      },
    });
  }

  removeService(id: number): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: REMOVE_SERVICE,
      variables: { id },
    });
  }

  removeServiceTask(id: number): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: REMOVE_SERVICE_TASK,
      variables: { id },
    });
  }

  removeServiceTaskAssignment(id: number): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: REMOVE_SERVICE_TASK_ASSIGNMENT,
      variables: { id },
    });
  }
}
